import React from 'react';
import { useTheme } from 'styled-components';
import { GlanceCard, HealthRows, StageMix } from './ui';
import { HEALTH_PARTS } from './helpers';

/* Share of plants healthy, who got worse or better since their last check, and a bar per system. */
export default function PlantHealthCard({ crop }) {
  const theme = useTheme();

  const health = {
    // Same system order as the Growth card beside it, so the two sets of rack rows line up;
    // the worst rack shows as the reddest bar, and the plants to look at are in Needs you.
    systems: crop.rows.filter(r => r.plants?.total),
    status: crop.unhealthy ? 'warning' : crop.stressed ? 'notice' : crop.total ? 'normal' : 'offline',
    word: crop.unhealthy ? `${crop.unhealthy} unhealthy` : crop.stressed ? `${crop.stressed} stressed` : crop.total ? 'All healthy' : 'No plants',
  };

  // Third figure: today's checks once there are any, else how many have gone a week unchecked.
  const checkedToday = crop.newToday?.plants_checked || 0;
  const unchecked = Math.max(0, crop.total - (crop.checkedWeek || 0));
  const fmt = n => (n || 0).toLocaleString('en-IN');

  return (
    <GlanceCard to="/plant-viewer" $status={health.status}>
      <div className="k">Plant health <span className="word"><i />{health.word}</span></div>
      <div className="big">
        {crop.total ? <>{Math.round((crop.healthy / crop.total) * 100)}%<small>healthy, {fmt(crop.healthy)} of {fmt(crop.total)}</small></>
          : <>No plants<small>logged yet</small></>}
      </div>
      {crop.total > 0 && (
        <div className="facts" title="Each plant's latest check against the one before it">
          <div><b>{fmt(crop.worse)}</b><span>got worse</span></div>
          <div><b>{fmt(crop.better)}</b><span>got better</span></div>
          {checkedToday > 0 || !unchecked
            ? <div><b>{fmt(checkedToday)}</b><span>checked today</span></div>
            : <div><b>{fmt(unchecked)}</b><span>unchecked 7 d</span></div>}
        </div>
      )}
      {health.systems.length > 0 && (
        <StageMix>
          <HealthRows>
            {health.systems.map(r => (
              <li key={r.system_id} title={`${r.name}: ${r.healthy} healthy, ${r.stressed} stressed, ${r.unhealthy} unhealthy`}>
                <span>{r.name}</span>
                <span className="bar">
                  {HEALTH_PARTS.map(([k, c]) => r[k] > 0
                    && <i key={k} style={{ flex: r[k], background: theme.colors[c] }} />)}
                </span>
                <span>{r.healthy} of {r.plants.total}</span>
              </li>
            ))}
          </HealthRows>
          <div className="key">
            {HEALTH_PARTS.map(([k, c, label]) => (
              <span key={k}><i style={{ background: theme.colors[c] }} />{label} <b>{fmt(crop[k])}</b></span>
            ))}
          </div>
        </StageMix>
      )}
    </GlanceCard>
  );
}
